/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RiderEvent } from '../../models/rider-event';
import { RiderEventPost } from '../../models/rider-event-post';

export interface RacesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost$Params {
  raceGuid: string;
  horseCombinationNumber: number;
      body: RiderEventPost
}

export function racesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost(http: HttpClient, rootUrl: string, params: RacesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RiderEvent>> {
  const rb = new RequestBuilder(rootUrl, racesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost.PATH, 'post');
  if (params) {
    rb.path('raceGuid', params.raceGuid, {"style":"simple"});
    rb.path('horseCombinationNumber', params.horseCombinationNumber, {"style":"simple"});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RiderEvent>;
    })
  );
}

racesRaceGuidHorsecombinationsHorseCombinationNumberRidersRidereventsPost.PATH = '/races/{raceGuid}/horsecombinations/{horseCombinationNumber}/riders/riderevents';
